// extracted by mini-css-extract-plugin
module.exports = {"smallMarginY":"styles-module__smallMarginY___3xl58","mediumMarginY":"styles-module__mediumMarginY___1h1HS","largeMarginY":"styles-module__largeMarginY___2Yfhj"};